import React, { useState } from 'react';
import {
    StyleSheet,
    TextInput,
    Text,
    View
} from 'react-native';
import { MainNavProps } from "../navigation/main/MainParamList";
import { color_929292, color_BEBEBE } from "../../assets/style/colors";
import { addFriend } from "../../net/service";
import { Str_AddFriends, Str_AddFriendTip, Str_Cancel, Str_Send, Str_SendFriendApply } from "../../language/string_res";
import { hideLoading, showLoading } from '../../components/Loading';
import { showToast } from "../../components/Toast";
import { useStore } from '../../store/UserStore';
import { ScreenCancelModal } from '../../components/ScreenModal';




export function ContactApply({
    navigation,
    route,
}: MainNavProps<'ContactApply'>) {
    const uid = route.params?.uid || 0;
    const { state } = useStore();
    const user = state?.user;
    const [value, setValue] = useState('');

    function sendMsg() {
        let helloText = value
        if (value.length === 0 && user?.nick?.length) {
            helloText = `我是${user.nick}`
        }
        const body = { touid: uid, hello: helloText, scene: 'phone' };
        showLoading()
        addFriend(body).then((resp) => {
            hideLoading()
            console.log('friend apply add: ', resp);
            if (resp.code === 0) {
                showToast(Str_AddFriendTip)
                navigation.goBack();
                setTimeout(() => {
                    navigation.goBack();
                }, 100);
            } else {
                showToast(resp.msg ?? '')
            }
        });
    }

    return (
        <ScreenCancelModal title={Str_AddFriends}
            leftText={Str_Cancel}
            rightText={Str_Send} onRightPress={sendMsg} >
            <View style={{
                borderRadius: 5,
                flexDirection: 'row',
                backgroundColor: "#EDEDED",
                alignItems: 'center',
                marginHorizontal: 12,
                paddingHorizontal: 10,
                height: 50,
                justifyContent: 'space-between',
                marginTop: 12,
            }}>
                <TextInput
                    placeholder={Str_SendFriendApply}
                    placeholderTextColor={color_BEBEBE}
                    autoFocus={true}
                    maxLength={32}
                    value={value}
                    onChangeText={setValue}
                    style={styles.inputContainer}
                />
                <Text style={{
                    fontSize: 12,
                    color: color_929292,
                    marginEnd: 2
                }}>{value.length}/{32}</Text>
            </View>
        </ScreenCancelModal>
    );
}

const styles = StyleSheet.create({
    inputContainer: {
        fontSize: 15,
        color: "#333333",
        flex: 1,
        backgroundColor:'red',
        height: 50,
    },
});
